import { useAuth0 } from "@auth0/auth0-react";
import React, { useCallback, useContext, useEffect, useState } from "react";
import Api from "../services/Api";
import UserUtils from "../utils/userUtils";


export const UserInfoContext = React.createContext();

export const useUserInfoContext = () => useContext(UserInfoContext);

export const UserInfoContextProvider = (props) => {
  const {isAuthenticated, getAccessTokenSilently, isLoading, user} = useAuth0();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState(null);
  
  //effect for getting and setting user info if Authenticated
  useEffect(() => {
    const apiCall = async () => {
      if (!isLoading && isAuthenticated){ //is logged in by  auth0
        let token = await getAccessTokenSilently();
        Api.setAuthorizationHeader(token);
        //get user info from API, check if authorized
        let userInfoLcl = await Api.getUserInfo();
        setUserInfo(userInfoLcl);
        setIsAuthorized(userInfoLcl !== null && typeof userInfoLcl === 'object');
        setLoading(false);
      }else if (!isLoading && !isAuthenticated){
        setUserInfo(null);
        setIsAuthorized(false);
        setLoading(false);
      }
    }
    setLoading(true);
    apiCall();
  }, [isAuthenticated, getAccessTokenSilently, isLoading, setUserInfo]);

  const hasRole = (roleName) => {
    if (isAuthorized && userInfo){
      return UserUtils.checkIfUserHasRole(userInfo, roleName);
    }else{
      return false;
    }
  }

  const hasRoleMemo = useCallback((roleName) => {
    if (isAuthorized && userInfo){
      return UserUtils.checkIfUserHasRole(userInfo, roleName);
    }else{
      return false;
    }
  }, [isAuthorized, userInfo]);
  

  return ( 
  <UserInfoContext.Provider
    value={{
      isAuthorized,
      userInfo,
      isLoading: loading,
      user,
      isAuthenticated,
      checkIfUserHasRole: hasRoleMemo
    }}
  >
    {props.children}
  </UserInfoContext.Provider>
  )

}

export default UserInfoContextProvider;